export const getCartIdWithoutSystemInfo = (completeCartId: string): string => {
  const parts = completeCartId.split('-');
  if (parts.length === 2 && parts[1].length > 0) {
    return parts[1];
  }
  return completeCartId;
};
